<template>
  <transition name="dialog-fade">
    <div v-if="visible" class="dialog-overlay" @click.self="cancel">
      <div class="dialog-box">
        <div class="dialog-icon">
          <slot name="icon">!</slot>
        </div>
        <h2 class="dialog-title">
          <slot name="title">Are you sure?</slot>
        </h2>
        <p class="dialog-body">
          <slot>This action cannot be undone.</slot>
        </p>
        <div :class="['dialog-actions', { 'dialog-actions--centered': !showCancel }]">
          <button v-if="showCancel" class="dialog-btn dialog-btn--cancel" @click="cancel">
            {{ cancelLabel }}
          </button>
          <button class="dialog-btn dialog-btn--confirm" @click="confirm">
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    confirmLabel: {
      type: String,
      default: 'Confirm'
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
    },
    confirm() {
      this.$emit('confirm');
      this.$emit('update:visible', false);
    }
  }
}
</script>

<style scoped>
/* ── Overlay ── */
.dialog-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 8, 7, 0.6);
}

/* ── Dialog box ── */
.dialog-box {
  background-color: var(--surface-dark);
  border: 2px solid var(--text-bright);
  border-radius: 4px;
  padding: 32px 28px 24px;
  max-width: 360px;
  width: 90%;
  text-align: left;
  filter: url(#button-stroke);
  box-shadow: 0 8px 32px rgba(0, 8, 7, 0.5);
}

/* ── Exclamation icon ── */
.dialog-icon {
  text-align: center;
  font-family: var(--font-family-balsamiq);
  font-size: 32px;
  color: var(--text-bright);
  margin-bottom: 8px;
}

/* ── Title ── */
.dialog-title {
  font-family: Cabin-Sketch, cursive;
  font-weight: bold;
  font-size: 24px;
  line-height: 1.2;
  color: var(--text-lightest);
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 12px;
}

/* ── Body text ── */
.dialog-body {
  font-family: var(--font-family-balsamiq);
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-lightest);
  margin: 0 0 24px;
}

/* ── Action buttons row ── */
.dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: flex-start;
}

.dialog-actions--centered {
  justify-content: center;
}

.dialog-btn {
  font-family: var(--font-family-balsamiq);
  font-size: 14px;
  line-height: 24px;
  padding: 6px 14px;
  border-radius: 1px;
  cursor: pointer;
  border: 2px solid var(--text-bright);
  background-color: transparent;
  color: var(--text-bright);
  filter: url(#button-stroke);
  white-space: nowrap;
}

.dialog-btn--cancel {
  border-color: transparent;
  color: var(--text-bright);
  text-decoration: underline;
  text-decoration-skip-ink: none;
  filter: none;
}

.dialog-btn--confirm {
  background-color: var(--surface-darkest);
  color: var(--text-bright);
}

/* ── Transitions ── */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}
.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

.dialog-fade-enter-active .dialog-box,
.dialog-fade-leave-active .dialog-box {
  transition: transform 0.2s ease;
}
.dialog-fade-enter .dialog-box {
  transform: scale(0.95);
}
</style>
